import type { Choice } from "@memorang/types";

export type MatchingPairBankSide = "left" | "right";

export type MatchingPairProps = {
	left: Choice[];
	right: Choice[];
	leftLabel?: string;
	rightLabel?: string;
	/** Column whose items are draggable; the other is fixed with drop slots. Defaults to "right". */
	bankSide?: MatchingPairBankSide;
	/** fixed-item id -> placed bank-item id */
	values: Record<string, string>;
	onChangeValues: (values: Record<string, string>) => void;
	disabled?: boolean;
	isAnswered?: boolean;
	inReviewMode?: boolean;
	/** fixed-item id -> correct bank-item id, for review styling */
	correctTokenIdBySlot?: Record<string, string>;
};

export const BANK_DROPPABLE_ID = "bank";

export const getChoiceById = (choices: Choice[], id?: string) =>
	choices.find((choice) => choice.id === id);

type ResolveArgs = {
	left: Choice[];
	right: Choice[];
	bankSide: MatchingPairBankSide;
};

export const resolveMatchingPairColumns = ({
	left,
	right,
	bankSide,
}: ResolveArgs) => {
	const bankIsRight = bankSide === "right";
	return {
		fixedItems: bankIsRight ? left : right,
		bankItems: bankIsRight ? right : left,
		fixedOnLeft: bankIsRight,
	};
};
